var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "fill-height",
      "width": "500",
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.toggleStatus
    }
  }), _c('v-card', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('v-card-title', [_vm._v(" Ellacard contacts "), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-n3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _c('v-card-subtitle', [_c('router-link', {
    attrs: {
      "to": {
        name: 'account-contacts'
      }
    }
  }, [_vm._v("Manage contacts"), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1), _c('div', {
    staticClass: "flex-grow-0 d-flex align-center"
  }, [!_vm.single ? _c('v-checkbox', {
    staticClass: "mt-n1 ml-4",
    attrs: {
      "hide-details": "",
      "readonly": "",
      "indeterminate": !!(_vm.nRowsSelected && _vm.nRowsSelected < _vm.rows.length),
      "input-value": !!_vm.nRowsSelected
    },
    on: {
      "click": _vm.toggleAll
    }
  }) : _vm._e(), _c('contacts-search', {
    attrs: {
      "content-class": "ma-2",
      "types": _vm.types
    },
    on: {
      "search": function (v) {
        return _vm.search = v;
      }
    }
  })], 1), _c('contacts-table', {
    staticClass: "flex-grow-1 overflow-auto",
    attrs: {
      "search": _vm.search,
      "types": _vm.types,
      "rows": _vm.rows
    },
    on: {
      "update:types": function ($event) {
        _vm.types = $event;
      },
      "update:rows": function ($event) {
        _vm.rows = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item-prefix",
      fn: function (_ref) {
        var item = _ref.item;
        return [!_vm.single ? _c('v-checkbox', {
          staticClass: "mt-0 mr-3",
          attrs: {
            "hide-details": "",
            "readonly": "",
            "indeterminate": !!_vm.getSelected(item.contact).indeterminate,
            "input-value": !!_vm.getSelected(item.contact).n
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggle(item.contact);
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "item-targets",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', {
          staticClass: "ma-n1"
        }, [item.contact.email ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": "",
            "color": _vm.getSelected(item.contact).email ? 'primary' : null,
            "disabled": !!item.contact.email && _vm.forceSelectedKeys.has(item.contact.email.toLowerCase())
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggleKey(item.contact, 'email');
            }
          }
        }, [_vm._v(" " + _vm._s(item.contact.email) + " ")]) : _vm._e(), item.contact.phone ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": "",
            "color": _vm.getSelected(item.contact).phone ? 'primary' : null,
            "disabled": _vm.forceSelectedKeys.has(item.contact.phone)
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.toggleKey(item.contact, 'phone');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm._f("phone")(item.contact.phone)) + " ")]) : _vm._e()], 1)];
      }
    }])
  }), _c('v-divider'), _c('v-card-actions', {
    staticClass: "flex-grow-0"
  }, [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }